/**
 * referral_channels — SNS 広告 / QR / 紙チラシなど外部チャネルのタグ付けプリセット。
 *
 * Firestore: /referral_channels/{id}
 *
 * 用途:
 *   - audience_events.metadata.refTag に書き込まれる「チャネル識別子」を中央管理
 *   - キャンペーンボードの referral カードや UrlGeneratorPage で選択肢として提示
 *   - 命名揺れ（fb_a / fbA / facebook_a）を防止
 *
 * refTag バリデーション: [A-Za-z0-9_.-]{1,32}
 *   recordLandingView / submitForm の正規表現と一致させる。
 */
import type { IsoOrTimestamp } from './common';

export interface ReferralChannel {
  /** 表示名（例: "Facebook 広告 A 案"） */
  name: string;
  /** URL に入る識別子（例: "fb_creativeA"）。recordLandingView の正規表現と一致する文字種のみ */
  refTag: string;
  /** チャネル種別ラベル（例: "SNS 広告" "QR コード" "紙媒体"）— UI フィルタ・色分けに利用 */
  category?: string;
  /** 任意メモ */
  description?: string;
  /** UI 表示色（任意、CSS color 値） */
  color?: string;
  /** 利用回数（denormalized: 生成 URL の発行回数や監査用） */
  usageCount?: number;
  createdBy: string;
  createdAt: IsoOrTimestamp;
  updatedAt: IsoOrTimestamp;
}

/** refTag のバリデーション（functions / admin-web 共通で使用） */
export const REFERRAL_TAG_RE = /^[A-Za-z0-9_.-]{1,32}$/;

export function isValidRefTag(s: string | null | undefined): s is string {
  return typeof s === 'string' && REFERRAL_TAG_RE.test(s);
}
